import * as React from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { getUxTemplate, UxAccordion, useStateUxTemplate } from '../Bs4UxTemplates';
import Bs4I18N from '../../Bs4I18N';

export const TYPE_BS4REPORTTABULATOR = 'type_Bs4ReportTabulator';

export default class Bs4ReportTabulatorUx {  

  constructor(optionType, id, optionId) {
    this.optionType = optionType;
    this.id = id;
    this.optionId = optionId;
  }

  setUxTemplate = (id)  => {
    if (id) this.id = id;    
    this.uxTemplate = getUxTemplate(this.defaultUxTemplate, this.optionType, this.id, this.optionId);
  }

  defaultUxTemplate = {
    class: 189,
    name: 'Bs4ReportTabulator',
    body: {        
      ReportTabulator: {
        table: {},
        header: {
          padding: '8px 0px 8px 0px',
          borderColor: 'rgba(0, 0, 0, 0.16)',
          borderWidth: '1px 0px 0px 0px',
        },
        group: {
          padding: '8px 0px 8px 0px',
          borderColor: 'rgba(0, 0, 0, 0.16)',
          borderWidth: '1px 0px 0px 0px',
        },
        row: {
          padding: '8px 0px 8px 0px',
          borderColor: 'rgba(0, 0, 0, 0.16)',
          borderWidth: '1px 0px 0px 0px',
        },
        cell: {},
        verticalLine: {}        
      },
    },
  };

  getUxTemplateEditor = (uxEditor) => {
    const type = TYPE_BS4REPORTTABULATOR
    const eds = [{
      label: Bs4I18N.getTT('Table', 'Table', 'Bs4ReportTabulator'),
      types: [TYPE_BS4REPORTTABULATOR],
      onReset: () => this.uxTemplate.body.ReportTabulator.table = JSON.parse(JSON.stringify(this.defaultUxTemplate.body.ReportTabulator.table)),
      Content: (props) => {
        const uxBody = this.uxTemplate.body.ReportTabulator;

        return (
          <Box display='flex' flexDirection='column' p={1.5}>
            <Stack direction="row" justifyContent="space-around" alignItems="center" spacing={1}>
              <uxEditor.ViewCssColor types={type} value={uxBody.table} name='color' title='Tekst'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.table} name='backgroundColor' title='Tło'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.table} name='borderColor' title='Ramka'/>
            </Stack>                                  

            <uxEditor.ViewCssShadow types={type} value={uxBody.table} name='elevation'/>
            <uxEditor.ViewCssText types={type} value={uxBody.table} name='borderRadius'/>
            <uxEditor.ViewCssText types={type} value={uxBody.table} name='borderWidth'/>

            <uxEditor.ViewCssText types={type} value={uxBody.table} name='margin'/>
            <uxEditor.ViewCssText types={type} value={uxBody.table} name='padding'/>
          </Box>
        );
      },
    }, {
      label: Bs4I18N.getTT('Header', 'Header', 'Bs4ReportTabulator'),
      types: [TYPE_BS4REPORTTABULATOR],
      onReset: () => this.uxTemplate.body.ReportTabulator.header = JSON.parse(JSON.stringify(this.defaultUxTemplate.body.ReportTabulator.header)),      
      Content: (props) => {
        const uxBody = this.uxTemplate.body.ReportTabulator;

        return (
          <Box display='flex' flexDirection='column' p={1.5}>
            <Stack direction="row" justifyContent="space-around" alignItems="center" spacing={1}>
              <uxEditor.ViewCssColor types={type} value={uxBody.header} name='color' title='Tekst'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.header} name='backgroundColor' title='Tło'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.header} name='borderColor' title='Ramka'/>
            </Stack>                                  

            <uxEditor.ViewCssShadow types={type} value={uxBody.header} name='elevation'/>
            <uxEditor.ViewCssText types={type} value={uxBody.header} name='borderRadius'/>
            <uxEditor.ViewCssText types={type} value={uxBody.header} name='borderWidth'/>

            <uxEditor.ViewCssText types={type} value={uxBody.header} name='margin'/>
            <uxEditor.ViewCssText types={type} value={uxBody.header} name='padding'/>
          </Box>
        );
      },
    }, {
      label: Bs4I18N.getTT('Row', 'Row', 'Bs4ReportTabulator'),
      types: [TYPE_BS4REPORTTABULATOR],
      onReset: () => this.uxTemplate.body.ReportTabulator.row = JSON.parse(JSON.stringify(this.defaultUxTemplate.body.ReportTabulator.row)),
      Content: (props) => {
        const uxBody = this.uxTemplate.body.ReportTabulator;

        return (
          <Box display='flex' flexDirection='column' p={1.5}>
            <Stack direction="row" justifyContent="space-around" alignItems="center" spacing={1}>
              <uxEditor.ViewCssColor types={type} value={uxBody.row} name='color' title='Tekst'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.row} name='backgroundColor' title='Tło'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.row} name='borderColor' title='Ramka'/>
            </Stack>                                  

            <uxEditor.ViewCssShadow types={type} value={uxBody.row} name='elevation'/>
            <uxEditor.ViewCssText types={type} value={uxBody.row} name='borderRadius'/>
            <uxEditor.ViewCssText types={type} value={uxBody.row} name='borderWidth'/>

            <uxEditor.ViewCssText types={type} value={uxBody.row} name='minHeight'/>
            <uxEditor.ViewCssText types={type} value={uxBody.row} name='margin'/>
            <uxEditor.ViewCssText types={type} value={uxBody.row} name='padding'/>
          </Box>
        );
      },
    }, {
      label: Bs4I18N.getTT('Group row', 'Group row', 'Bs4ReportTabulator'),
      types: [TYPE_BS4REPORTTABULATOR],
      onReset: () => this.uxTemplate.body.ReportTabulator.group = JSON.parse(JSON.stringify(this.defaultUxTemplate.body.ReportTabulator.group)),      
      Content: (props) => {
        const uxBody = this.uxTemplate.body.ReportTabulator;

        return (
          <Box display='flex' flexDirection='column' p={1.5}>
            <Stack direction="row" justifyContent="space-around" alignItems="center" spacing={1}>
              <uxEditor.ViewCssColor types={type} value={uxBody.group} name='color' title='Tekst'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.group} name='backgroundColor' title='Tło'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.group} name='borderColor' title='Ramka'/>
            </Stack>                                  

            <uxEditor.ViewCssShadow types={type} value={uxBody.group} name='elevation'/>
            <uxEditor.ViewCssText types={type} value={uxBody.group} name='borderRadius'/>
            <uxEditor.ViewCssText types={type} value={uxBody.group} name='borderWidth'/>

            <uxEditor.ViewCssText types={type} value={uxBody.group} name='margin'/>
            <uxEditor.ViewCssText types={type} value={uxBody.group} name='padding'/>
          </Box>
        );
      },
    }, {
      label: Bs4I18N.getTT('Cell', 'Cell', 'Bs4ReportTabulator'),
      types: [TYPE_BS4REPORTTABULATOR],
      onReset: () => this.uxTemplate.body.ReportTabulator.cell = JSON.parse(JSON.stringify(this.defaultUxTemplate.body.ReportTabulator.cell)),
      Content: (props) => {
        const uxBody = this.uxTemplate.body.ReportTabulator;

        return (
          <Box display='flex' flexDirection='column' p={1.5}>
            <Stack direction="row" justifyContent="space-around" alignItems="center" spacing={1}>
              <uxEditor.ViewCssColor types={type} value={uxBody.cell} name='color' title='Tekst'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.cell} name='backgroundColor' title='Tło'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.cell} name='borderColor' title='Ramka'/>
            </Stack>                                  

            <uxEditor.ViewCssShadow types={type} value={uxBody.cell} name='elevation'/>
            <uxEditor.ViewCssText types={type} value={uxBody.cell} name='borderRadius'/>
            <uxEditor.ViewCssText types={type} value={uxBody.cell} name='borderWidth'/>

            <uxEditor.ViewCssText types={type} value={uxBody.cell} name='minHeight'/>
            <uxEditor.ViewCssText types={type} value={uxBody.cell} name='margin'/>
            <uxEditor.ViewCssText types={type} value={uxBody.cell} name='padding'/>
          </Box>
        );
      },
    }, {
      label: Bs4I18N.getTT('Vertical Line', 'Vertical Line', 'Bs4ReportTabulator'),
      types: [TYPE_BS4REPORTTABULATOR],
      onReset: () => this.uxTemplate.body.ReportTabulator.verticalLine = JSON.parse(JSON.stringify(this.defaultUxTemplate.body.ReportTabulator.verticalLine)),
      Content: (props) => {
        const uxBody = this.uxTemplate.body.ReportTabulator;

        return (
          <Box display='flex' flexDirection='column' p={1.5}>
            <uxEditor.ViewCssColor types={type} value={uxBody.verticalLine} name='backgroundColor' title='Tło'/>
            <uxEditor.ViewCssShadow types={type} value={uxBody.verticalLine} name='elevation'/>
            <uxEditor.ViewCssText types={type} value={uxBody.verticalLine} name='width'/>            
          </Box>
        );
      },
    }]    
    
    return [{
      label: Bs4I18N.getTT('Tabulator', 'Tabulator', 'Bs4ReportTabulator'), //+' '+this.optionId,
      getUxTemplate: () => this.uxTemplate,
      setUxTemplate: this.setUxTemplate,
      types: [TYPE_BS4REPORTTABULATOR],
      Content: (props) => {
        const [expanded, setExpanded] = React.useState(eds[0].label);
        const {} = useStateUxTemplate([TYPE_BS4REPORTTABULATOR])
        const handleChange = (panel) => (event, isExpanded) => {
          console.log('... UxAccordion .Main. .handleChange.', panel, isExpanded)
          setExpanded(isExpanded ? panel : false);
        };
  
        console.log('... UxAccordion .Main.', props)

        return (
          <React.Fragment>
            {eds.map((ux, index) => {
              return (
                <UxAccordion 
                  key={index} 
                  label={ux.label} 
                  types={ux.types}
                  expanded={expanded} 
                  onChange={handleChange} 
                  onReset={ux.onReset}
                >
                  <ux.Content/>
                </UxAccordion>
              )
            })}
          </React.Fragment>
        )
      },
    }]
  }
}